import { env } from './env';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    login: {
      path: '/login',
      getHref: (redirectTo?: string) => `/login${redirectTo ? `?redirectTo=${redirectTo}` : ''}`,
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
    callback: {
      path: env.OIDC_CALLBACK_PATH,
      getHref: () => env.OIDC_CALLBACK_PATH,
    },
  },

  onboarding: {
    path: 'onboarding',
    getHref: () => '/o/onboarding',
  },

  error: {
    path: '/error',
    getHref: () => '/error',
  },

  org: {
    root: {
      path: '/o',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    dashboard: {
      path: '',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    select: {
      path: 'select',
      getHref: () => '/o/select',
    },
    selected: {
      path: ':orgId',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    users: {
      path: 'users',
      getHref: (orgId: string) => `/o/${orgId}/users`,
    },
    settings: {
      path: 'settings',
      getHref: (orgId: string) => `/o/${orgId}/settings`,
    },
    userProfile: {
      path: 'user',
      getHref: (orgId?: string) => (orgId ? `/o/${orgId}/user` : '/o/user'),
    },
    orgProfile: {
      path: 'profile',
      getHref: (orgId: string) => `/o/${orgId}/profile`,
    },
    user: {
      path: 'user/:userId',
      getHref: (orgId: string, userId: string) => `/o/${orgId}/user/${userId}`,
    },
    roles: {
      path: 'roles',
      getHref: (orgId: string) => `/o/${orgId}/roles`,
    },
    apps: {
      path: 'apps',
      getHref: (orgId: string) => `/o/${orgId}/apps`,
    },
    app: {
      path: 'apps/:appId',
      getHref: (orgId: string, appId: string) => `/o/${orgId}/apps/${appId}`,
    },
  },

  admin: {
    root: {
      path: '/admin',
      getHref: () => '/admin',
    },
    dashboard: {
      path: '',
      getHref: () => '/admin',
    },
    users: {
      path: 'users',
      getHref: () => '/admin/users',
    },
    orgs: {
      path: 'orgs',
      getHref: () => '/admin/orgs',
    },
    roles: {
      path: 'roles',
      getHref: () => '/admin/roles',
    },
    profile: {
      path: 'profile',
      getHref: () => '/admin/profile',
    },
    user: {
      path: 'user/:userId',
      getHref: (userId: string) => `/admin/user/${userId}`,
    },
    apps: {
      path: 'apps',
      getHref: () => '/admin/apps',
    },
    app: {
      path: 'apps/:appId',
      getHref: (appId: string) => `/admin/apps/${appId}`,
    },
  },
} as const;
